import { createRuntimeEnvProxy, parseRuntimeConfig } from "runtime-config";
import * as v from "valibot";

export const publicRuntimeConfigSchema = v.object({
  frontUrl: v.pipe(v.string(), v.url()),
  purchaseUrl: v.pipe(v.string(), v.url()),
  assetsUrl: v.pipe(v.string(), v.url()),
  algoliaAppId: v.pipe(v.string(), v.nonEmpty()),
  algoliaSearchApiKey: v.pipe(v.string(), v.nonEmpty()),
  meiliFrontUrl: v.pipe(v.string(), v.url()),
  meiliFrontApiKey: v.pipe(v.string(), v.nonEmpty()),
  stripePublishableKey: v.pipe(v.string(), v.nonEmpty()),
  googleMapsApiKey: v.pipe(v.string(), v.nonEmpty()),
  authUrl: v.pipe(v.string(), v.nonEmpty()),
  atSiteId: v.pipe(v.string(), v.nonEmpty()),
  atCollectionDomain: v.pipe(v.string(), v.url()),
});

export type PublicRuntimeConfig = v.InferOutput<typeof publicRuntimeConfigSchema>;

export const getPublicRuntimeConfig = () =>
  parseRuntimeConfig(
    publicRuntimeConfigSchema,
    {
      frontUrl: process.env.FRONT_URL,
      purchaseUrl: process.env.PURCHASE_URL,
      assetsUrl: process.env.ASSETS_URL,
      algoliaAppId: process.env.ALGOLIA_APP_ID,
      algoliaSearchApiKey: process.env.ALGOLIA_SEARCH_API_KEY,
      meiliFrontUrl: process.env.MEILI_FRONT_URL,
      meiliFrontApiKey: process.env.MEILI_FRONT_API_KEY,
      stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
      googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
      authUrl: process.env.AUTH_URL,
      atSiteId: process.env.AT_SITE_ID,
      atCollectionDomain: process.env.AT_COLLECTION_DOMAIN,
    },
    "intermedes",
  );

export const env = createRuntimeEnvProxy({
  schema: publicRuntimeConfigSchema,
  getServerConfig: getPublicRuntimeConfig,
  appName: "intermedes",
  aliases: {
    frontUrl: "frontUrl",
    purchaseUrl: "purchaseUrl",
    assetsUrl: "assetsUrl",
    algoliaAppId: "algoliaAppId",
    algoliaSearchApiKey: "algoliaSearchApiKey",
    meiliFrontUrl: "meiliFrontUrl",
    meiliFrontApiKey: "meiliFrontApiKey",
    stripePublishableKey: "stripePublishableKey",
    googleMapsApiKey: "googleMapsApiKey",
    authUrl: "authUrl",
    atSiteId: "atSiteId",
    atCollectionDomain: "atCollectionDomain",
  },
});
